<template>
  <Card class="my-4">
    <LabeledValues label="Key">{{ props.tfaKey }} ({{ props.keyBase }})</LabeledValues>
    <LabeledValues label="Time">{{ props.time.toISOString() }}</LabeledValues>
    <LabeledValues label="Integer timestamp">{{ integerTime }}</LabeledValues>
    <LabeledValues label="Interval">{{ props.interval }} s</LabeledValues>
    <LabeledValues label="Time/interval">{{ (reducedTime).toFixed(3) }}</LabeledValues>
    <LabeledValues label="Time rounded in hex">{{ hexTime }}</LabeledValues>
    <LabeledValues label="HMAC-SHA-1">
      <span>{{ encrypted.slice(0, encrypted.length-1) }}</span>
      <span class="font-bold">{{ encrypted.slice(encrypted.length-1) }}</span>
    </LabeledValues>
    <LabeledValues label="Offset">{{ offset }}</LabeledValues>
    <LabeledValues label="Offset code">
      <span>{{ encrypted.slice(0, offset) }}</span>
      <span class="font-bold">{{ encrypted.slice(offset, offset+8) }}</span>
      <span>{{ encrypted.slice(offset+8) }}</span>
    </LabeledValues>
    <LabeledValues label="Decimal value">{{ parseInt(fullCode, 16) }}</LabeledValues>
    <LabeledValues label="Last 31 bits">{{ parseInt(fullCode, 16) & 0x7fffffff }}</LabeledValues>
    <LabeledValues label="8-digit code">{{ code }}</LabeledValues>
    <LabeledValues label="6-digit code">{{ code.slice(2,8) }}</LabeledValues>
  </Card>
</template>

<script setup>
  import Crypto from 'crypto-js'
  import Card from '../components/Card.vue'
  import LabeledValues from '../components/LabeledValues.vue'
  import {reactive} from 'vue'
  import {getCode, BasedValue} from '../../helpers/tfa.js'


  let props = defineProps({
    tfaKey: String,
    keyBase: String,
    time: Date,
    interval: Number,
    expectedCode: String
  })


  let integerTime = props.time.valueOf()
  let reducedTime = integerTime/props.interval/1000
  let hexTime = BasedValue(Math.floor(reducedTime), 10).toString(16,64)

  let key = props.tfaKey
  let time = props.time
  let interval = props.interval
  // Copied and updated from getCode
  let timeTag = Math.floor(time.valueOf() / 1000 / interval)
  timeTag = BasedValue(timeTag, 10).toWords(64)
  let encrypted = Crypto.HmacSHA1(timeTag, key).toString()
  let offset = parseInt(encrypted.at(-1),16)*2
  let fullCode = encrypted.split("").splice(offset, 8).join("")
  let code = parseInt(fullCode, 16) & 0x7fffffff
  code = code.toString().slice(-8).padStart(8,"0")

</script>